
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcToggleButtonOption as ObcToggleButtonOptionElement} from '@oicl/openbridge-webcomponents/dist/components/toggle-button-option/toggle-button-option.js';
 
 
 

 
 export const ObcToggleButtonOption = createComponent({
   react: React,
   tagName: 'obc-toggle-button-option',
   elementClass: ObcToggleButtonOptionElement,
   events: {
     
     onSelected: 'selected' as EventName<CustomEvent<{value: string}>>,
   }
  });
 
 